import angular from 'angular';
import ngRedux from 'ng-redux'; // eslint-disable-line no-unused-vars

import store from './store';
/**
 * @ngdoc overview
 * @name myConsultApp
 * @description
 * # myConsultApp
 *
 * Main module of the application.
 */
angular
  .module('myConsultApp', [
    'ngAnimate',
    'ngAria',
    'ngCookies',
    'ngMessages',
    'ngResource',
    'ngRoute',
    'ngSanitize',
    'angularjs-datetime-picker',
    'oc.lazyLoad',
    'http-auth-interceptor',
    'config',
    'ui.bootstrap',
    'angular-google-analytics',
    'uiGmapgoogle-maps',
    'ng.deviceDetector',
    'blockUI',
    'crumble',
    'angucomplete',
    'pwr-angucomplete-alt',
    'pro-receipt-upload-angucomplete',
    'admin-user-search-angucomplete',
    'admin-angucomplete',
    'breed-list-angucomplete',
    'ngFileUpload',
    'ngStorage',
    'com.2fdevs.videogular',
    'ngRedux',
    'chart.js',
  ])
  .constant('AUTH_EVENTS', {
    loginSuccess: 'auth-login-success',
    loginFailed: 'auth-login-failed',
    logoutSuccess: 'auth-logout-success',
    sessionTimeout: 'auth-session-timeout',
    notAuthenticated: 'auth-not-authenticated',
    notAuthorized: 'auth-not-authorized',
  })
  .constant('USER_ROLES', {
    all: '*',
    admin: 'admin',
    editor: 'editor',
    guest: 'guest',
  })
  .constant('ATLAS_API', {
    clientId: 'hEk5hpYrWaWkjSgIUJ5F9VnWx6mxnhz78j6R2ya5',
  })
  .constant('GAMainConfig', {
    local: 'UA-XXXXX-X',
    development: 'UA-72953943-1',
    uat: 'UA-72967833-1',
    demo: 'UA-72957735-1',
    staging: 'UA-72977822-1',
    production: 'UA-69127003-1',
  })
  .constant('LOCATION_API', {
    ipLocation: 'https://ipapi.co/json/',
    googleMap: 'https://maps.googleapis.com/maps/api/',
  })
  // Device detector module
  .config(($ngReduxProvider) => {
    $ngReduxProvider.provideStore(store);
  })
  .config([
    'deviceDetectorProvider',
    (deviceDetectorProvider) => {
      deviceDetectorProvider.addCustom('My_Custom_Detector', {
        or: ['\\bChrome\\b', '\\bFirefox\\b', '\\bSafari\\b'],
      });
    },
  ])
  .config((AnalyticsProvider, GAMainConfig, ENV) => {
    const accountID = GAMainConfig[ENV.name];
    // console.log('GA Account loaded: ' + accountID);
    AnalyticsProvider.setAccount(accountID);
    AnalyticsProvider.useDisplayFeatures(true);
  })
  .config((blockUIConfig) => {
    blockUIConfig.autoBlock = true;
    blockUIConfig.autoInjectBodyBlock = true;
    blockUIConfig.requestFilter = (config) => {
      if (
        config.url.match(/identities\/\?search/gi) ||
        config.url.match(/identities\/\?applications/gi) ||
        config.url.match(/providers\/\?directory_type/gi)
      ) {
        return false;
      }
      if (config.method) {
        let message;
        switch (config.method) {
          case 'GET':
            if (
              config.url.match(/patients/gi) &&
              config.params !== undefined &&
              config.params.order !== undefined
            ) {
              message = 'Sorting ...';
            } else {
              message = 'Loading ...';
            }
            break;

          case 'POST':
            message = 'Saving ...';
            break;

          case 'DELETE':
            message = 'Deleting ...';
            break;
          case 'PUT':
            message = 'Updating ...';
            break;
          default:
            break;
        }
        return message;
      }
    };
  })
  .config(($routeProvider, $locationProvider, $resourceProvider, $httpProvider) => {
    $routeProvider
      .when('/', {
        templateUrl: 'views/dashboard.html',
        controller: 'DashboardCtrl',
        label: 'Dashboard',
      })
      .when('/find-a-pet', {
        templateUrl: 'views/find-a-patient.html',
        controller: 'findAPatientCtrl',
        label: 'Find a Pet',
      })
      .when('/media', {
        templateUrl: 'views/media.html',
        controller: 'mediaCtrl',
        label: 'Media',
      })
      .when('/media/edit/:mediaId', {
        templateUrl: 'views/catpainiq-detail.html',
        controller: 'catpainiqDetail',
        label: 'Review Media',
        parent: '/catpainiq/',
      })
      .when('/catpainiq', {
        templateUrl: 'views/catpainiq-dashboard.html',
        controller: 'catpainiqDashboard',
        label: 'Cat Pain IQ',
      })
      .when('/experience-solensia', {
        templateUrl: 'views/iep-dashboard.html',
        controller: 'iepDashboardController',
        label: 'Experience Solensia',
      })
      .when('/experience-solensia/:petId', {
        templateUrl: 'views/iep-detail.html',
        controller: 'iepDetailViewController',
        label: 'Review Pet Program',
      })
      .when('/experience-librela', {
        templateUrl: 'views/iep-dashboard.html',
        controller: 'iepDashboardController',
        label: 'Experience librela',
      })
      .when('/experience-librela/:petId', {
        templateUrl: 'views/iep-detail.html',
        controller: 'iepDetailViewController',
        label: 'Review Pet Program',
      })
      .when('/login', {
        templateUrl: 'views/login.html',
        controller: 'loginCtrl',
      })
      .when('/logout', {
        templateUrl: 'views/logout.html',
        controller: 'logoutCtrl',
      })
      .when('/terms-of-use/', {
        templateUrl: 'views/terms-of-use.html',
        controller: 'TOUCtrl',
      })
      .when('/clinic-settings', {
        redirectTo: '/organization/settings',
      })
      .when('/organization', {
        redirectTo: '/organization/settings',
        label: 'Organization',
      })
      .when('/organization/settings', {
        templateUrl: 'views/edit-organization-settings.html',
        controller: 'editOrganizationSettings',
        label: 'Edit Organization',
        reloadOnSearch: false,
      })
      .when('/pets/:petId/dashboard', {
        redirectTo: '/find-a-pet/:petId',
      })
      .when('/find-a-pet/create', {
        templateUrl: 'views/create-pro-pet.html',
        controller: 'createProPet',
        label: 'Create Pet',
        parent: '/find-a-pet/',
        reloadOnSearch: false,
      })
      .when('/find-a-pet/:petId', {
        templateUrl: 'views/pet-overview.html',
        controller: 'petoverviewCtrl',
        label: 'Pet Dashboard',
      })
      .when('/find-a-pet/edit/:ownerId/:petId', {
        templateUrl: 'views/edit-pro-pet.html',
        controller: 'editProPet',
        label: 'Edit Pet',
        parent: '/find-a-pet/:petId/',
        reloadOnSearch: false,
      })
      .when('/rewards', {
        templateUrl: 'views/pet-owner-rewards-application.html',
        controller: 'PetOwnerRewardsApplicationCtrl',
        label: 'Pet Owner Rewards',
      })
      .when('/rewards/pro-rewards-resources', {
        templateUrl: 'views/cms-template.html',
        controller: 'RewardsFAQCtrl',
        label: 'Resources',
        reloadOnSearch: false,
      })
      .when('/rewards/receipt-upload', {
        templateUrl: 'views/upload-client-receipt.html',
        controller: 'uploadReceipt',
        label: 'Upload Receipt',
        reloadOnSearch: false,
      })
      .when('/admin', {
        templateUrl: 'views/v2/administrative-dashboard.html',
        controller: 'administrativeDashboardCtrl',
        label: 'Administrative Dashboard',
      })
      .when('/admin/receipt-upload', {
        templateUrl: 'views/upload-client-receipt.html',
        controller: 'uploadReceipt',
        label: 'Upload Receipt',
        reloadOnSearch: false,
      })
      .when('/admin/loyalty/activities/manage-activity-types', {
        templateUrl: 'views/v2/manage-activity-types-list.html',
        controller: 'manageActivityTypeList',
        label: 'Manage Activity Types',
        parent: '/admin',
      })
      .when('/admin/loyalty/activities/manage-activity-types/:activityId', {
        templateUrl: 'views/v2/manage-activity-types-list.html',
        controller: 'manageActivityTypeList',
        label: 'Manage Activity Types',
        parent: '/admin',
      })
      .when('/admin/loyalty/activities/manage-promotion-codes', {
        templateUrl: 'views/v2/manage-promotion-codes-list.html',
        controller: 'managePromotionCodeList',
        label: 'Manage Promotion Codes',
        parent: '/admin',
      })
      .when('/admin/loyalty/activities/manage-promotion-codes/:promoCodeId', {
        templateUrl: 'views/v2/manage-promotion-codes-list.html',
        controller: 'managePromotionCodeList',
        label: 'Manage Promotion Codes',
        parent: '/admin',
      })
      .when('/admin/loyalty/activities/manage-user-activities', {
        templateUrl: 'views/v2/manage-user-activity.html',
        controller: 'manageUserActivity',
        label: 'Manage User Activities',
        parent: '/admin',
      })
      .when('/admin/loyalty/activities/manage-user-activities/:activityId', {
        templateUrl: 'views/v2/manage-user-activity.html',
        controller: 'manageUserActivity',
        label: 'Manage User Activities',
        parent: '/admin',
      })
      .when('/admin/loyalty/activities/manage-user-activities/media/:mediaId', {
        templateUrl: 'views/v2/manage-user-activity.html',
        controller: 'manageUserActivity',
        label: 'Manage User Activities',
        parent: '/admin',
      })
      .when('/admin/loyalty/activities/manage-user-activities/pet-detail/:petId', {
        templateUrl: 'views/v2/manage-user-activity.html',
        controller: 'manageUserActivity',
        label: 'Manage User Activities',
        parent: '/admin',
      })
      .when('/admin/loyalty/activities/manage-user-activities/redemption-detail/:redemptionId', {
        templateUrl: 'views/v2/manage-user-activity.html',
        controller: 'manageUserActivity',
        label: 'Manage User Activities',
        parent: '/admin',
      })
      .when('/admin/loyalty/activities/manage-user-activities/transaction-detail/:transactionId', {
        templateUrl: 'views/v2/manage-user-activity.html',
        controller: 'manageUserActivity',
        label: 'Manage User Activities',
        parent: '/admin',
      })
      .when('/admin/loyalty/points/inaccuracies', {
        templateUrl: 'views/v2/manage-point-inaccuracies-list.html',
        controller: 'managePointInaccuraciesList',
        label: 'Manage Point Inaccuracies',
        parent: '/admin',
      })
      .when('/admin/loyalty/reward-redemptions/manage-rewards', {
        templateUrl: 'views/v2/manage-rewards-list.html',
        controller: 'manageRewardList',
        label: 'Manage Rewards',
        parent: '/admin',
      })
      .when('/admin/loyalty/reward-redemptions/manage-rewards/:rewardId', {
        templateUrl: 'views/v2/manage-rewards-list.html',
        controller: 'manageRewardList',
        label: 'Manage Rewards',
        parent: '/admin',
      })
      .when('/admin/loyalty/reward-redemptions/manage-redemptions', {
        templateUrl: 'views/v2/manage-redemption-list.html',
        controller: 'manageRedemptionList',
        label: 'Manage Redemptions',
        parent: '/admin',
      })
      // COMMENTED ON 6/17/21 - shouldn't be needed anymore but leaving just in case
      // .when('/admin/loyalty/reward-redemptions/manage-redemptions/unmatched', {
      //   templateUrl: 'views/wirecard-list.html',
      //   controller: 'wirecardListCtrl',
      //   label: 'View Unmatched Wirecard Reconcilation Records',
      //   parent: '/admin',
      // })
      .when('/admin/loyalty/reward-redemptions/manage-redemptions/:redemptionId', {
        templateUrl: 'views/v2/manage-redemption-list.html',
        controller: 'manageRedemptionList',
        label: 'Manage Redemptions',
        parent: '/admin',
      })
      .when('/admin/loyalty/transactions/manage-products', {
        templateUrl: 'views/v2/manage-product-list.html',
        controller: 'manageProductList',
        label: 'Manage Products',
        parent: '/admin',
      })
      .when('/admin/loyalty/transactions/manage-products/:productId', {
        templateUrl: 'views/v2/manage-product-list.html',
        controller: 'manageProductList',
        label: 'Manage Products',
        parent: '/admin',
      })
      .when('/admin/loyalty/transactions/manage-purchase-locations', {
        templateUrl: 'views/v2/manage-purchase-location-list.html',
        controller: 'managePurchaseLocationList',
        label: 'Manage Purchase Locations',
        parent: '/admin',
      })
      .when('/admin/loyalty/transactions/manage-purchase-locations/:purchaseLocationId', {
        templateUrl: 'views/v2/manage-purchase-location-list.html',
        controller: 'managePurchaseLocationList',
        label: 'Manage Purchase Locations',
        parent: '/admin',
      })
      .when('/admin/loyalty/transactions/manage-transactions', {
        templateUrl: 'views/v2/manage-transaction-list.html',
        controller: 'manageTransactionList',
        label: 'Manage Transactions',
        parent: '/admin',
      })
      .when('/admin/loyalty/transactions/manage-transactions/:transactionId', {
        templateUrl: 'views/v2/manage-transaction-list.html',
        controller: 'manageTransactionList',
        label: 'Manage Transactions',
        parent: '/admin',
      })
      .when('/admin/loyalty/transactions/manage-transactions/pet-detail/:petId', {
        templateUrl: 'views/v2/manage-transaction-list.html',
        controller: 'manageTransactionList',
        label: 'Manage Transactions',
        parent: '/admin',
      })
      .when('/admin/organizations/manage-organizations', {
        templateUrl: 'views/v2/manage-organization-list.html',
        controller: 'manageOrganizationList',
        label: 'Manage Organizations',
        parent: '/admin',
      })
      .when('/admin/organizations/manage-organizations/:organizationId', {
        templateUrl: 'views/v2/manage-organization-list.html',
        controller: 'manageOrganizationList',
        label: 'Manage Organizations',
        parent: '/admin',
      })
      .when('/admin/organizations/manage-organizations/create', {
        templateUrl: 'views/create-organization.html',
        controller: 'createOrganization',
        label: 'Create Organization',
        parent: '/admin/organizations/manage-organizations/',
      })
      .when('/admin/organizations/manage-organizations/view/edit/:orgId', {
        templateUrl: 'views/edit-organization.html',
        controller: 'editOrganization',
        parent: '/admin/organizations/manage-organizations',
        label: 'Edit Organization',
        reloadOnSearch: false,
      })
      .when('/admin/pets/manage-pets', {
        templateUrl: 'views/v2/manage-pet-list.html',
        controller: 'managePetList',
        label: 'Manage Pets',
        parent: '/admin',
      })
      .when('/admin/pets/manage-pets/:petId', {
        templateUrl: 'views/v2/manage-pet-list.html',
        controller: 'managePetList',
        label: 'Manage Pets',
        parent: '/admin',
      })
      .when('/admin/pets/manage-pets/edit-pet/:petId', {
        templateUrl: 'views/v2/manage-pet-list.html',
        controller: 'managePetList',
        label: 'Manage Pets',
        parent: '/admin',
      })
      .when('/admin/pets/manage-pets/pet-detail/:petDetailId', {
        templateUrl: 'views/v2/manage-pet-list.html',
        controller: 'managePetList',
        label: 'Manage Pets',
        parent: '/admin',
      })
      .when('/admin/pets/manage-pets/pet-detail/:petDetailId/media/:mediaId', {
        templateUrl: 'views/v2/manage-pet-list.html',
        controller: 'managePetList',
        label: 'Manage Pets',
        parent: '/admin',
      })
      // COMMENTED ON 6/17/21 - shouldn't be needed anymore but leaving just in case
      // .when('/admin/pets/manage-pets/create/', {
      //   templateUrl: 'views/create-pro-pet.html',
      //   controller: 'createProPet',
      //   label: 'Create Pet',
      //   parent: '/admin',
      //   reloadOnSearch: false,
      // })
      // .when('/admin/pets/manage-pets/:petId', {
      //   templateUrl: 'views/pet-overview.html',
      //   controller: 'petoverviewCtrl',
      //   label: 'Pet Dashboard',
      //   parent: '/admin',
      // })
      // .when('/admin/pets/manage-pets/edit/:ownerId/:petId', {
      //   templateUrl: 'views/edit-pro-pet.html',
      //   controller: 'editProPet',
      //   label: 'Edit Pet',
      //   parent: '/admin',
      //   reloadOnSearch: false,
      // })
      .when('/admin/reporting-database/manage-salesforce-imports', {
        templateUrl: 'views/v2/manage-salesforce-import-list.html',
        controller: 'manageSalesforceImportList',
        label: 'Manage Salesforce Imports',
        parent: '/admin',
      })
      .when('/admin/reporting-database/manage-salesforce-imports/:salesforceImportId', {
        templateUrl: 'views/v2/manage-salesforce-import-list.html',
        controller: 'manageSalesforceImportList',
        label: 'Manage Salesforce Imports',
        parent: '/admin',
      })
      .when('/admin/media/story-list', {
        templateUrl: 'views/v2/story-list.html',
        controller: 'storyList',
        label: 'Share Your Story Submissions',
        parent: '/admin',
      })
      .when('/admin/media/manage-media', {
        templateUrl: 'views/v2/manage-media-list.html',
        controller: 'manageMediaList',
        label: 'Manage Media',
        parent: '/admin',
      })
      .when('/admin/media/manage-media/:mediaId', {
        templateUrl: 'views/v2/manage-media-list.html',
        controller: 'manageMediaList',
        label: 'Media Detail',
        parent: '/admin',
      })
      .when('/admin/third-party/ip-whitelist', {
        templateUrl: 'views/v2/manage-white-list.html',
        controller: 'manageWhiteList',
        label: 'Manage Third Party IP Whitelist',
        parent: '/admin',
      })
      .when('/admin/third-party/ip-whitelist/:ipWhitelistId', {
        templateUrl: 'views/v2/manage-white-list.html',
        controller: 'manageWhiteList',
        label: 'Manage Third Party IP Whitelist',
        parent: '/admin',
      })
      .when('/admin/users/manage-users', {
        templateUrl: 'views/v2/manage-user-list.html',
        controller: 'manageUserList',
        label: 'Manage Users',
        parent: '/admin',
      })
      .when('/admin/users/manage-users/:userId', {
        templateUrl: 'views/v2/user-profile.html',
        controller: 'userProfile',
        label: 'Manage User Activities',
        parent: '/admin',
      })
      .when('/admin/users/manage-users/:userId/:componentId', {
        templateUrl: 'views/v2/user-profile.html',
        controller: 'userProfile',
        label: 'Manage User Activities',
        parent: '/admin',
      })
      .when('/admin/users/manage-users/:userId/media/:mediaId', {
        templateUrl: 'views/v2/user-profile.html',
        controller: 'userProfile',
        label: 'Manage User Activities',
        parent: '/admin',
      })
      .when('/admin/users/manage-users/:userId/edit-pet/:petId', {
        templateUrl: 'views/v2/user-profile.html',
        controller: 'userProfile',
        label: 'Manage User Activities',
        parent: '/admin',
      })
      .when('/admin/users/manage-users/:userId/pet-detail/:petDetailId', {
        templateUrl: 'views/v2/user-profile.html',
        controller: 'userProfile',
        label: 'Manage User Activities',
        parent: '/admin',
      })
      .when('/admin/users/manage-users/:userId/organization-detail/:organizationId', {
        templateUrl: 'views/v2/user-profile.html',
        controller: 'userProfile',
        label: 'Manage User Activities',
        parent: '/admin',
      })
      .when('/admin/users/manage-users/:userId/redemption-detail/:redemptionId', {
        templateUrl: 'views/v2/user-profile.html',
        controller: 'userProfile',
        label: 'Manage User Activities',
        parent: '/admin',
      })
      .when('/admin/users/manage-users/:userId/transaction-detail/:transactionId', {
        templateUrl: 'views/v2/user-profile.html',
        controller: 'userProfile',
        label: 'Manage User Activities',
        parent: '/admin',
      })
      // COMMENTED ON 6/17/21 - shouldn't be needed anymore but leaving just in case
      // .when('/admin/users/manage-users/:userId/edit', {
      //   templateUrl: 'views/edit-user.html',
      //   controller: 'editUser',
      //   label: 'Edit User',
      //   parent: '/admin',
      // })
      // .when('/admin/users/manage-users/:userId/redeem', {
      //   templateUrl: 'views/user-redemption.html',
      //   controller: 'userRedemption',
      //   label: 'Redeem Rewards',
      //   parent: '/admin',
      // })
      .when('/:slug', {
        templateUrl: 'views/cms-template.html',
        controller: 'CmsCtrl',
        label: 'CMS Template',
      })
      .otherwise({
        redirectTo: '/login',
      });

    $locationProvider.html5Mode(true);
    $resourceProvider.defaults.stripTrailingSlashes = false;
    $httpProvider.defaults.withCredentials = true;
    $httpProvider.interceptors.push('myCSRF');
    $httpProvider.interceptors.push('ResourceInterceptor');
    $httpProvider.defaults.xsrfCookieName = 'csrftoken';
    $httpProvider.defaults.xsrfHeaderName = 'X-CSRFToken';
    // $httpProvider.interceptors.push('sessionRefresher');
  })
  .config((uiGmapGoogleMapApiProvider) => {
    uiGmapGoogleMapApiProvider.configure({
      key: 'AIzaSyDVynpgBDGeElAMIhTtA8VjcgoJlX9m3dw',
      v: '3.27',
      libraries: 'weather,geometry,visualization',
    });
  })
  .config(($sceDelegateProvider) => {
    $sceDelegateProvider.resourceUrlWhitelist([
      // Allow same origin resource loads.
      'self',
      'https://cdns.us1.gigya.com/**',
    ]);
  })
  .value('redirectToUrlAfterLogin', { url: '/' })
  .run([
    '$rootScope',
    '$route',
    '$routeParams',
    '$location',
    'AuthService',
    ($rootScope) => {
      $rootScope.$on('$routeChangeStart', (_, next) => {
        if (next && next?.$$route?.originalPath?.indexOf('/admin') !== -1) {
          $rootScope.adminPage = true;
        } else {
          $rootScope.adminPage = false;
        }
      });
    },
  ])
  .run([
    '$http',
    '$cookies',
    ($http, $cookies) => {
      $http.defaults.headers.post['X-CSRFToken'] = $cookies.csrftoken;
    },
  ])
  .run([
    '$route',
    '$rootScope',
    '$location',
    ($route, $rootScope, $location) => {
      const original = $location.path;
      $location.path = (path, reload) => {
        if (path && reload === false) {
          const lastRoute = $route.current;
          const un = $rootScope.$on('$locationChangeSuccess', () => {
            $route.current = lastRoute;
            un();
          });
        }
        return original.apply($location, [path]);
      };
    },
  ])
  .run([
    'AuthService',
    '$rootScope',
    '$injector',
    '$location',
    '$timeout',
    'crumble',
    'UserService',
    (AuthService, $rootScope, $injector, $location, $timeout, crumble, UserService) => {
      const getParent = crumble.getParent;

      crumble.getParent = (path) => {
        const route = crumble.getRoute(path);
        return route && angular.isDefined(route.parent) ? route.parent : getParent(path);
      };

      if (!UserService.isValid()) {
        AuthService.saveAttemptUrl();
        $location.path('/login');
      }

      if (UserService.checkSuperUser()) {
        // console.log('Is Super User');
        $timeout(() => {
          // console.log('add-superuser-config');
          $rootScope.$broadcast('add-superuser-config');
        }, 300);
      }

      // HTTP INTERCEPTOR BROADCAST METHOD

      $rootScope.$on('event:auth-loginRequired', () => {
        // console.log('auth-required');

        const ATLAS_API = $injector.get('ATLAS_API');
        const Session = $injector.get('Session');
        const authService = $injector.get('authService'); // http interceptor service
        const ownAuthService = $injector.get('AuthService'); // our auth service

        const credentials = {
          client_id: ATLAS_API.clientId,
          grant_type: 'refresh_token',
          refresh_token: Session.refreshToken,
        };

        ownAuthService.refreshToken(credentials).then(
          (response) => {
            // update access_token
            Session.setTokens(response.access_token, response.refresh_token, response.expires_in);
            authService.loginConfirmed();
          },
          () => {
            // redirect to login page
            // console.log(response);
            Session.removeTokens();
            $location.path('/login');
            $('#login-form').show();
            $('#login-form').html(
              `<div class='text-center'>
                    <h4>
                        There appears to be a problem with your Petcare Pro subscription. For assistance please call Customer Service  1-888-ZOETIS-1, 1-888-963-8471 Select Option #1. We apologize for any inconvenience.
                    </h4>
                </div>`,
            );
          },
        );
      });
    },
  ]);
